<div *ngIf="!loadingComponent && minDate; else loading">
  <!-- ORDER TERMS -->
  <div class="row">
    <div class="col-12 col-md-4">
      <div [formGroup]="form">
        <lib-meta-select-input
          formControlName="levsattkod"
          table="x2f"
          metaId="levsattkod"
          metaDisplay="levsattbeskr"
          [optionsFilterFunction]="optionsFilterDeliveryMethod.bind(this, currentCustomer)"
          [optionsFilterChangeUpdate]="filterMetadataUpdate.asObservable()"
          (ngModelChange)="onDeliveryMethodChanged($event)"
        >
        </lib-meta-select-input>
      </div>
    </div>
    <div class="col-12 col-md-4" *ngIf="!isUser">
      <div [formGroup]="form">
        <lib-meta-select-input formControlName="betkod" table="x2" metaId="betkod" metaDisplay="betvillbeskr">
        </lib-meta-select-input>
      </div>
    </div>
    <div class="col-12 col-md-4" *ngIf="!isUser">
      <div [formGroup]="form">
        <lib-meta-select-input formControlName="saljare" table="salj" metaId="saljare" metaDisplay="saljarenamn">
        </lib-meta-select-input>
      </div>
    </div>
    <div class="col-12 col-md-4" *ngIf="!isUser">
      <div [formGroup]="form">
        <lib-meta-select-input
          formControlName="levvillkkod"
          table="x2e"
          metaId="levvillkkod"
          metaDisplay="levvillkbeskr"
        >
        </lib-meta-select-input>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="form-group" [formGroup]="form">
        <label for="partDelivery" class="control-label" translate>PART_DELIVERY</label>
        <select
          name="partDelivery"
          id="partDelivery"
          class="form-control"
          formControlName="dellevtillaten"
          (change)="handlePartDeliveryChange()"
        >
          <option [value]="entry.id" *ngFor="let entry of partDeliveryEntries">
            {{ entry.name | translate }}
          </option>
        </select>
        <div class="error-form" *ngIf="form.get('dellevtillaten').value === '' || !form.get('dellevtillaten').value" translate>DELIVERY_CHOICE_REQUIRED</div>
      </div>
    </div>
    <div *ngIf="checkout.extra.oh.dellevtillaten == '10'" class="col-12 col-md-4">
      <div>
        <lib-delivery-date-picker
          *ngIf="minDate"
          (selectedDate)="dateSelected($event)"
          [initialDate]="checkout.extra.oh.ordberlevdat"
          [currentselectedDate]="checkout.extra.oh.ordberlevdat"
          [deliveryMethod]="form.get('levsattkod').value"
          [minInitialDate]="minDate"
        ></lib-delivery-date-picker>
      </div>

      <div *ngIf="form.get('dellevtillaten').value === '0'" translate>PART_DELIVERY_MESSAGE</div>
    </div>

    <div *ngIf="currentCustomer.extra.fr.landskod !== 'SE'" class="col-12 col-md-4 align-self-center">
      <input
        type="checkbox"
        id="arranges_freight"
        name="arranges_freight"
        [(ngModel)]="checkout.extra.oh.q_oh_ownfreight"
      />
      <label for="arranges_freight" class="ml-2">{{ arrangesFreightLabel | translate }}</label>
      <ng-container *ngIf="!isHelo">
        <br/>
        <i style="font-size: 12px;" translate>TYLO_ARRANGES_FREIGH_TERM</i>
      </ng-container>
    </div>

    <!-- <div class="col-12 col-md-4" *ngIf="!isUser">
            <div class="form-group" [formGroup]="form">
                <label for="ordstat " class="control-label" translate>ORDER_TYPE</label>
                <select name="ordstat " id="ordstat " class="form-control form-select" formControlName="ordstat">
                    <option [value]="0" translate><span></span>OTTO_OLSEN_QUOTATION</option>
                    <option [value]="10" translate>OTTO_OLSEN_ORDER</option>
                </select>
            </div>
        </div> -->
  </div>
  <div class="row">
    <!-- FREIGHT COST -->
    <div *ngIf="form.get('betkod').value === '29' || form.get('betkod').value === '37'" class="col-12 mb-2">
      <div class="alert mt-2 text-center alert-cart-note" role="alert">
        <span style="white-space: break-spaces;" translate>TYLO_CART_NOTE_29_37</span>
      </div>
    </div>
    <div class="col-12 mb-2" *ngIf="checkout.extra.oh.q_oh_ownfreight">
      <div class="alert mt-2 text-center alert-cart-note" role="alert">
        <span translate>TYLO_ARRANGES_FREIGH_NOTE</span>
      </div>
    </div>
    <div class="col-12 mb-2" *ngIf="hasTempFreightArticles">
      <div class="alert mt-2 text-center alert-cart-note" role="alert">
        <span translate>TYLO_TEMP_FREIGHT_DESCRIPTION</span>
      </div>
    </div>
    <div class="col-12">
      <div *ngIf="alertMessageFreightCost" class="alert mt-2 text-center alert-primary" role="alert">
        <span [innerHTML]="alertMessageFreightCost.message"></span>
      </div>
    </div>

    <!-- ADMIN FEES -->
    <!-- <div class="col-12 text-center">
            <div *ngIf="alertMessageAdminFee" class="alert mt-2 text-center alert-{{alertMessageAdminFee.type}}"
                role="alert">
                {{ alertMessageAdminFee.message | translate }}
            </div>
        </div> -->
  </div>
  <!-- CART LIST -->
  <div class="row">
    <div class="col-12" *ngIf="!isUser">
      <lib-filter-list #cartList [configService]="salesCartConfigService"></lib-filter-list>
    </div>
    <div class="col-12" *ngIf="isUser">
      <lib-filter-list #cartList [configService]="cartConfigService"></lib-filter-list>
    </div>
  </div>
</div>

<ng-template #loading translate> LOADING </ng-template>
